import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import Dropdown from 'react-bootstrap/Dropdown';
import chevronDown from '../../../../assets/images/icons/chevronDown.svg';

import './ActionDropdown.scss';
import { putRequest, deleteRequest } from '../../../requestUtils';

class ActionDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handlePutRequest = this.handlePutRequest.bind(this);
  }

  handlePutRequest(link, updateStateHandler) {
    const { csrfToken } = this.props;
    if (link) {
      putRequest(
        link,
        {},
        csrfToken,
      ).then((response) => {
        updateStateHandler(response.data);
      }).catch((err) => {
        if (err) {
          alert(err);
        }
      });
    }
  }

  handleDeleteRequest(link, redirectHandler) {
    const { csrfToken } = this.props;
    if (link && confirm('Are you sure you want to delete this?')) {
      deleteRequest(
        link,
        csrfToken,
      ).then((response) => {
        redirectHandler(response.data);
      }).catch((err) => {
        if (err) {
          alert(err);
        }
      });
    }
  }

  renderItem(link) {
    const { id } = this.props;

    switch (link[0]) {
      case 'separator':
        return (<hr key={link[4]} />);
      case 'put':
        return (
          <button
            type="button"
            key={link[1]}
            className="dropdown-item"
            onClick={() => this.handlePutRequest(link[2], link[3])}
          >
            {link[1]}
          </button>
        );
      case 'delete':
        return (
          <div className="delete-container">
            <button
              type="button"
              key={link[1]}
              className="delete-link"
              onClick={() => this.handleDeleteRequest(link[2], link[3])}
            >
              {link[1]}
            </button>
            <i className="fa fa-trash-alt" />
          </div>
        );
      case 'link':
        return (
          <a
            key={`${id}-${link[1]}`}
            className={`dropdown-item ${link[4]}`}
            href={link[2]}
            target={link[3]}
          >
            {link[0] === 'link' ? link[1] : link[0]}
          </a>
        );
      default:
        return (
          <div className="dropdown-item">
            {link[1]}
          </div>
        );
    }
  }

  render() {
    const {
      id, links, defaultLabel, isDisabled, plainTrigger, menuStyle, toggleStyle, indicatorIcon,
      buttonVariant,
    } = this.props;

    return (
      <Dropdown size="md" className="bulk-actions-dropdown" disabled={isDisabled} id={id}>
        <Dropdown.Toggle
          variant={buttonVariant}
          tag={plainTrigger ? 'span' : 'button'}
          className={
            `nav-link dropdown-toggle bulk-action-label ${toggleStyle} ${isDisabled && 'disabled'}`
          }
        >
          { defaultLabel }
          {!plainTrigger && <SVG src={indicatorIcon || chevronDown} className="chevron" />}
        </Dropdown.Toggle>
        <Dropdown.Menu className={menuStyle}>
          {links.map((link) => (this.renderItem(link)))}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

ActionDropdown.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultLabel: PropTypes.node,
  links: PropTypes.arrayOf(PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.oneOf(['link', 'function', 'info', 'hidden', 'separator']),
      PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
      PropTypes.object,
    ]),
  )).isRequired,
  isDisabled: PropTypes.bool,
  plainTrigger: PropTypes.bool,
  toggleStyle: PropTypes.string,
  menuStyle: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  indicatorIcon: PropTypes.node,
  buttonVariant: PropTypes.string,
};

ActionDropdown.defaultProps = {
  id: 'bulk',
  defaultLabel: 'Actions',
  isDisabled: false,
  plainTrigger: false,
  toggleStyle: '',
  menuStyle: 'bulk-actions-menu',
  indicatorIcon: null,
  buttonVariant: 'primary',
};

export default ActionDropdown;
